import React from 'react';

import  Scintilla2024  from 'views/Scintilla2024';

const BlogNewsroomPage = () => {

return <Scintilla2024/>
};

export default BlogNewsroomPage;